import React from 'react'
import { Route } from 'react-router'
import config from '../../../common/config'
import MidMsgComponent from '../../../components/MidMsg'
import api from '../../../common/api'

function AuthRoute(props) {

    const searchParams = new URLSearchParams(props.location.search);

    if (searchParams.get('code')) {
      api.auth.exchangeAuthorizationCodeForToken(searchParams.get('code')).then(({ data: response }) => {
        sessionStorage.setItem('token', response);
        window.location.href = "/";
      });
    } else if (searchParams.get('token')) {
      sessionStorage.setItem('token', searchParams.get('token'));
      window.location.href = "/";
    } else if (sessionStorage.getItem('token')) {
      return <Route {...props} />;
    } else {
      api.auth.getOAuthInfo().then(({ data: response }) => {
        console.log(response);
        const params = new URLSearchParams();
        params.set('client_id', response.clientId);
        params.set('response_type', 'code');
        params.set('scope', response.scopes.join(' '));
        params.set('redirect_uri', response.redirectUri);
        params.set('code_challenge', response.codeChallenge);
        params.set('code_challenge_method', response.codeChallengeMethod);
        const redirectUrl = `${response.endpoint}/as/authorization.oauth2?${params.toString()}`;
        window.location.href = redirectUrl;
      });
    }

    return <MidMsgComponent title={'AUTENTICAZIONE IN CORSO'} description="Non siamo riusciti a trovare il tuo account. Resta in attesa finché ti portiamo alla nostra pagina di login."/>;

}

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/shared/security/AuthRoute/AuthRoute.js